/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { getIEVersion } from './helper.js';
import '../../../_chunks/dep-fd3498b6.js';
import '../../../_chunks/dep-2acfafca.js';
import '../../../_chunks/dep-92728dc5.js';
import '../../../_chunks/dep-e43cf21c.js';
import '../../../_chunks/dep-46de7b2e.js';
import '../../../_chunks/dep-6c5254c6.js';
import '../../../_chunks/dep-c3f1141e.js';
import '../../../_chunks/dep-4941ebe7.js';
import '../../../_chunks/dep-e9b62d1f.js';
import '../../../_chunks/dep-77e34309.js';
import '../../../_chunks/dep-7dce2c26.js';
import '../../../_chunks/dep-ec16db36.js';
import '../../../_chunks/dep-036ad2cc.js';
import '../../../_chunks/dep-0e15088f.js';

function getScrollbarWidthWithCSS() {
  var defaultScrollbarWidth = 6;
  if (typeof navigator === "undefined" || !navigator) return defaultScrollbarWidth;
  if (/(Chrome|Safari)/i.test(navigator.userAgent)) return defaultScrollbarWidth;
  var scrollDiv = document.createElement("div");
  scrollDiv.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  if (/Firefox/.test(navigator.userAgent)) {
    scrollbarWidth -= 4;
  }
  if (getIEVersion() <= 11) {
    scrollbarWidth = 12;
  }
  return scrollbarWidth;
}
function getScrollbarWidth() {
  var scrollDiv = document.createElement("div");
  scrollDiv.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;";
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

export { getScrollbarWidth, getScrollbarWidthWithCSS };
//# sourceMappingURL=getScrollbarWidth.js.map
